import { useTedsSandboxPageGet } from "@dealer-center/ddc-pages-teds-sandbox-page-fetch";

import { useEffect, useState } from "react";
import { PagesTedsSandboxPageUiDisplay } from "./Display";

export const PagesTedsSandboxPageUi = () => {
  const [form, setForm] = useState({ phone: "", name: "" });
  const { data, error, isLoading } = useTedsSandboxPageGet(form);
  useEffect(() => {
    document.title = "TedsSandboxPage";
  }, []);
  const submit = ({ phone, name }: { phone: string; name: string }) => {
    setForm({ phone, name });
  };

  return (
    <PagesTedsSandboxPageUiDisplay
      data={data}
      error={error}
      loading={isLoading}
      submit={submit}
    />
  );
};
